import * as Yup from 'yup';
import i18next from 'i18next';
import dayjs from 'dayjs';
import { RoleSlug } from 'src/shared/enums/roleSlug.enum';
import { registerValidationMethods } from '../schemaMethods';
import { validation } from '../validation';

registerValidationMethods();

export const VALIDATOR = {
  optionalEmail: Yup.string().matches(validation.email, i18next.t('validations.email')),
  email: Yup.string().matches(validation.email, i18next.t('validations.email')).required(i18next.t('validations.required')),
  password: Yup.string().min(8, 'Password must be at least 8 characters long').required(i18next.t('validations.required')),
  optionalPhone: Yup.string().phoneFormat(i18next.t('validations.phoneFormat')),
  phone: Yup.string().phoneFormat(i18next.t('validations.phoneFormat')).required(i18next.t('validations.required')),
  role: Yup.string().oneOf(Object.values(RoleSlug)).required(i18next.t('validations.required')),
  zipcode: Yup.string().matches(validation.zipCode, i18next.t('validations.zipCode')).required(i18next.t('validations.required')),
  yardArray: Yup.array().min(1, 'Required').required(i18next.t('validations.required')),
  name: Yup.string()
    .max(validation.nameLengthMax)
    .matches(/^[A-Za-z ]*$/, i18next.t('validations.onlyAlpha'))
    .required(i18next.t('validations.required')),
  requiredString: Yup.string().required(i18next.t('validations.required')),
  requiredNumber: Yup.number().required(i18next.t('validations.required')),
  requiredObject: Yup.object().required(i18next.t('validations.required')),
  gvwr: Yup.number().nullable().min(0).required(i18next.t('validations.required')),
  confirmPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters long')
    .oneOf([Yup.ref('password')], i18next.t('validations.doNotMatch'))
    .required(i18next.t('validations.required')),
  notes: Yup.string().max(500).required(i18next.t('validations.required')),
  startDate: Yup.number()
    .required(i18next.t('validations.required'))
    .test('is-not-past', 'Date should be in the future', (date) => !dayjs(date * 1000).isBefore(dayjs(), 'day')),
  title: Yup.string()
    .min(validation.nameLengthMin, `Name should be at least ${validation.nameLengthMin} characters long`)
    .required(i18next.t('validations.required')),
  website: Yup.string().nullable().matches(validation.website, i18next.t('validations.website')).required(i18next.t('validations.required')),
  mixed: Yup.mixed(),
  array: (elementSchema: Yup.AnySchema) =>
    Yup.array().of(elementSchema).min(1, i18next.t('validations.required')).required(i18next.t('validations.required')),
};
